"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var contests_core_1 = require("@biw/contests-core");
var contests_constants_1 = require("@biw/contests-constants");
function getNoProgressProps(state, program) {
    var programViewId = program.programViewId;
    var progressModel = contests_core_1.progress.selectors.getProgress(state, programViewId);
    return {
        tileType: 'no-progress',
        /* Goal Label */
        levelName: get_1.default(progressModel, 'selectedGoal.name', ''),
        levelDescription: get_1.default(progressModel, 'selectedGoal.description', ''),
        goalLabel: get_1.default(progressModel, 'goalOverview.goalLabelProps'),
        /* footer*/
        buttonTextCode: contests_constants_1.KEY_CODES.setyourplan,
        footerMessageCode: contests_constants_1.KEY_CODES.onyourmark,
        daysLeft: program.daysToProgramEndDate,
        calendarLabel: 'progress.daysToEarnLabel'
    };
}
exports.default = getNoProgressProps;
//# sourceMappingURL=no-progress-props.js.map